/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const meRetrieveResponseUsernameMax = 150;


export const meRetrieveResponseUsernameRegExp = new RegExp('^[\\w.@+-]+$');
export const meRetrieveResponseEmailMax = 254;

export const meRetrieveResponsePhoneNumberMax = 128;



export const MeRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "username": zod.string().max(meRetrieveResponseUsernameMax).regex(meRetrieveResponseUsernameRegExp).describe('Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.'),
  "email": zod.string().email().max(meRetrieveResponseEmailMax).optional(),
  "phoneNumber": zod.string().max(meRetrieveResponsePhoneNumberMax).optional(),
  "fullName": zod.string(),
  "consultantGroup": zod.string().nullable(),
  "clientGroup": zod.string().nullable(),
  "role": zod.union([zod.enum(['consultant', 'client', 'service_provider']).describe('\* `consultant` - consultant\n\* `client` - client\n\* `service_provider` - service_provider'),zod.literal(null)]).nullable(),
  "isLiftaiAdmin": zod.boolean(),
  "isGroupAdmin": zod.boolean(),
  "canAccessMechanicAssistant": zod.boolean().optional(),
  "canAccessSalesGenie": zod.boolean().optional(),
  "canAccessElevatorInsights": zod.boolean().optional(),
  "isDemo": zod.boolean()
}).strict()

export const MeConsultantGroupRetrieveResponse = zod.void()

export const MeWhatsNewRetrieveResponse = zod.object({
  "seenOn": zod.string().date().nullish(),
  "dialogSeenOn": zod.string().date().nullish()
}).strict()

export const MeWhatsNewPartialUpdateBody = zod.object({
  "seenOn": zod.string().date().nullish(),
  "dialogSeenOn": zod.string().date().nullish()
})

export const MeWhatsNewPartialUpdateResponse = zod.object({
  "seenOn": zod.string().date().nullish(),
  "dialogSeenOn": zod.string().date().nullish()
}).strict()

